import gql from 'graphql-tag';

const SUBMIT_INVENTORY_DETAILS = gql`
  mutation reviewInventoryRequest(
    $caseId: String
    $caseExternalId: String
    $parentEventType: String
    $parentEventSubType: String
    $accountId: String
    $branchId: String
    $salesRepId: String
    $shipToId: String
    $serviceLevel: String
    $needByDate: Date
    $shipMethod: String
    $lineItems: [ReviewInventoryRequestLineItems]
    $comments: [Comment]
    $isCancel: Boolean
    $cancelReason: String
    $expectedCaseVersion: String
    $system: String
    $version: String
  ) {
    reviewInventoryRequest(
      caseId: $caseId
      caseExternalId: $caseExternalId
      parentEventType: $parentEventType
      parentEventSubType: $parentEventSubType
      accountId: $accountId
      branchId: $branchId
      salesRepId: $salesRepId
      shipToId: $shipToId
      serviceLevel: $serviceLevel
      needByDate: $needByDate
      shipMethod: $shipMethod
      lineItems: $lineItems
      comments: $comments
      isCancel: $isCancel
      cancelReason: $cancelReason
      expectedCaseVersion: $expectedCaseVersion
      system: $system
      version: $version
    ) {
      message
      # Lines the reviewer approved that Salesforce had already turned into order lines. The backend
      # refuses to re-arm those and reports them here; without asking for them the refusal is a
      # silent skip. Nullable and additive — the field is absent on the other mutations that share
      # this response type.
      blockedOrderLines {
        usageId
        usageExternalId
        productId
        code
        message
      }
    }
  }
`;

export default SUBMIT_INVENTORY_DETAILS;
